<template>
  <operations-table entity="collection" />
</template>

<script>
import OperationsTable from '@/components/AdminOperations/OperationsTable.vue'
export default { name: 'LFAdminCollections', components: { OperationsTable } }
</script>
